import styled from 'styled-components'
import { BLACK, GRAYSCALE_50, PALE_BLUE, PALE_PURPLE } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const Container = styled.div`
  background-color: ${PALE_BLUE};
  border: 1px solid ${PALE_PURPLE};
  border-radius: 12px;
  padding: 16px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`

export const IconContainer = styled.div`
  background-color: ${GRAYSCALE_50};
  border-radius: 100%;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
`

export const ProviderIcon = styled.img`
  max-height: 40px;
  max-width: 40px;
`

export const ProviderName = styled.span`
  font-family: ${INTER.medium};
  font-size: 13px;
  color: ${BLACK};
`
